<script setup>
import { ref, reactive, computed } from "vue";

const props = defineProps({
  error: Boolean,
  digitCount: {
    type: Number,
    default: 4,
  },
});


const emit = defineEmits(["updated", "changed"]);

const otpCont = ref(null);
const digitArray = Array.from({ length: props.digitCount }, () => null);
const digits = reactive(digitArray);

const handleDelete = (index) => {
  if(index === 0) {
    return;
  }

  const prevInput = otpCont.value.children[index - 1];
  prevInput.focus();
  prevInput.select();
}

const handleChange = (index, event) => {
  const value = event.target.value?.split("")?.pop() || null;
  digits[index] = value;
  event.target.value = value;
  emit("changed", currentValue.value);

  if (!value) {
    return;
  }
  if (index < digits.length - 1) {
    otpCont.value.children[index + 1].focus();
  } else if (currentValue.value.length === props.digitCount) {
    emit("updated", currentValue.value);
  }
};

const handlePaste = (event) => {
  const paste = (event.clipboardData || window.clipboardData).getData('text');
  const pasteArray = paste.split("").slice(0, props.digitCount);
  let allFilled = true;
  
  pasteArray.forEach((char, index) => {
    if (!isNaN(char) && index < digits.length) {
      digits[index] = char;
    }
  });

  emit("changed", currentValue.value);
  if (currentValue.value.length === props.digitCount) {
    emit("updated", currentValue.value);
  }

  for (let i = 0; i < digits.length; i++) {
    if (!digits[i]) {
      allFilled = false;
      otpCont.value.children[i].focus();
      break;
    }
  }

  if(allFilled) {
    otpCont.value.children[otpCont.value.children.length - 1].focus();
  }

  event.preventDefault();
};

const currentValue = computed(() => digits.map((number) => number).join(""));
</script>

<template>
  <div class="otp-fields" ref="otpCont" dir="ltr" @paste="handlePaste">
    <input
      type="number"
      class="otp-field"
      :class="{'has-error': error}"
      v-for="(el, ind) in digits"
      :key="ind"
      :value="el"
      @input="handleChange(ind, $event)"
      @keyup.delete="handleDelete(ind, $event)"
      @focus="$event.target.select()"
      :autofocus="ind === 0"
    />
  </div>
</template>

<style scoped>
.otp-fields {
  display: flex;
  gap: 8px;
}
.otp-field {
  width: 2em;
  text-align: center;
  max-width: 2em;
}
</style>
